import styled from "styled-components";

import informationIcon from "../../../img/icons/information-icon.png";

import { MessageBanner, colors } from ".";

// using a PNG instead of an SVG
// because of some odd behavioral issues when
// trying to use the SVG version of this icon
const InformationIcon = styled.img.attrs({
    src: informationIcon
})`
    width: 1.4375rem;
    height: 1.4375rem;
`;

const messageBannerAttributes = {
    accentColor: colors.darkSkyBlue,
    icon: InformationIcon
};

export const InformationalMessageBanner = styled(MessageBanner).attrs(
    messageBannerAttributes
)``;
